<div class="migrate-events-container">
  <div class="tw-bg-white tw-border-b tw-border-gray-200 tw-px-8 tw-py-6">
    <div class="tw-flex tw-items-center tw-gap-4">
      <div class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-bg-blue-50 tw-rounded-lg">
        <svg viewBox="0 0 24 24" class="tw-w-6 tw-h-6 tw-fill-blue-600">
          <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V15H17V17M17,13H7V11H17V13M17,9H7V7H17V9Z" />
        </svg>
      </div>
      <div>
        <h1 class="tw-text-xl tw-font-semibold tw-text-gray-900">Migrate Events</h1>
        <p class="tw-text-sm tw-text-gray-500 tw-mt-1">Move events between organizations</p>
      </div>
    </div>
  </div>

  <div class="tw-px-8 tw-py-8 tw-max-w-6xl tw-mx-auto">
    <!-- Source Section -->
    <div class="tw-rounded-lg tw-p-6">
      <h2 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-4">Source</h2>
      
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
        <!-- Source Organization -->
        <div>
          <select-input
            #sourceOrgSelectInput
            [control]="sourceOrgControl"
            [label]="'Organization'"
            [placeholder]="'Search by workspace name, acronym, event name, or slug'"
            [values]="sourceOrgValues()"
            key="name"
            [valueName]="'id'"
            [isSingleSelect]="true"
            [enableSearch]="true"
            [isDropdown]="true"
            [basicSelect]="true"
            [isBasicDropdownValue]="true"
            [optionNoData]="isLoadingSourceOrgs() ? 'Loading...' : (hasAttemptedLoadSourceOrgs ? 'No organizations found' : '')"
            (valueChanged)="onSourceOrgValueChanged($event)"
            (onSearch)="onSourceOrgSearch($event)"
          ></select-input>
        </div>

        <!-- Source Event -->
        <div>
          <select-input
            #sourceEventSelectInput
            [control]="sourceEventControl"
            [label]="'Event'"
            [placeholder]="'Search by event name or slug'"
            [values]="sourceEventValues()"
            key="name"
            [valueName]="'id'"
            [isSingleSelect]="true"
            [enableSearch]="true"
            [isDropdown]="true"
            [basicSelect]="true"
            [isBasicDropdownValue]="true"
            [isDisabled]="!canSelectSourceEvent()"
            [optionNoData]="isLoadingSourceEvents() ? 'Loading...' : (canSelectSourceEvent() && hasAttemptedLoadSourceEvents ? 'No events found' : canSelectSourceEvent() ? '' : 'Select organization first')"
            (valueChanged)="onSourceEventValueChanged($event)"
            (onSearch)="onSourceEventSearch($event)"
          ></select-input>
        </div>
      </div>
    </div>

    <!-- Target Section -->
    @if(canSelectTarget()) {
      <div class="tw-rounded-lg tw-p-6">
        <h2 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-4">Target</h2>
        
        <!-- Target Organization -->
        <div>
          <select-input
            #targetOrgSelectInput
            [control]="targetOrgControl"
            [label]="'Organization'"
            [placeholder]="'Search by workspace name, acronym, event name, or slug'"
            [values]="targetOrgValues()"
            key="name"
            [valueName]="'id'"
            [isSingleSelect]="true"
            [enableSearch]="true"
            [isDropdown]="true"
            [basicSelect]="true"
            [isBasicDropdownValue]="true"
            [optionNoData]="isLoadingTargetOrgs() ? 'Loading...' : 'No organizations found'"
            (valueChanged)="onTargetOrgValueChanged($event)"
            (onSearch)="onTargetOrgSearch($event)"
          ></select-input>
        </div>

        <!-- Migrate Button -->
        <div class="tw-mt-6 tw-flex tw-justify-end">
          @if(canMigrate()) {
            <button
              (click)="onMigrateEvent()"
              class="tw-px-6 tw-py-3 tw-bg-blue-600 tw-text-white tw-font-medium tw-rounded-lg hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2 tw-transition-colors tw-flex tw-items-center tw-gap-2"
            >
              <svg class="tw-w-5 tw-h-5" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                <path d="M5 12h14M12 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Migrate Event
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
